// import React, { useState } from "react";
// import { Button, Checkbox } from "@mui/material";
// import "react-datepicker/dist/react-datepicker.css";
// import "react-toastify/dist/ReactToastify.css";
// import TopTitleFormComponent from "./TopTitleFormComponent";
// import { doc, serverTimestamp, setDoc } from "firebase/firestore";
// import { db } from "../../firebase";
// import { updateDoc, doc as firestoreDoc } from "firebase/firestore";
// import {
//   getDownloadURL,
//   getStorage,
//   ref,
//   uploadString,
// } from "firebase/storage";
// import { showCustomToast } from "../Misc/CustomToast";
// import SignaturePadComponentV2 from "../Signature/SignaturePadComponentV2";

// function AddTreatmentEngagementForm(props) {
//   const [checked1, setChecked1] = useState(false);
//   const [checked2, setChecked2] = useState(false);
//   const [checked3, setChecked3] = useState(false);
//   const [checked4, setChecked4] = useState(false);
//   const [checked5, setChecked5] = useState(false);
//   const [checked6, setChecked6] = useState(false);
//   const [checked7, setChecked7] = useState(false);
//   const [signatureDataURL, setSignatureDataURL] = useState(null);
//   const { clientId } = props;
//   const [isLoading, setIsLoading] = useState(false);
//   const [isSignatureValidated, setIsSignatureValidated] = useState(false);
//   const text1 =
//     "Miracles Asia’s treatment programme schedule has various activities throughout the entire week.  Each activity is an activity that is part of your recovery programme.  The program, in its entirety, is here to help clients change their life, continue the recovery process, build a strong foundation for recovery, and help maintain recovery. Therefore, clients are expected to attend ALL activities unless in the case of a medical waiver for not attending, immigration related requirements, or attendance is waived by your primary therapist, the Clinical Director, or the Managing Director prior to non-attendance.";

//   const text2 =
//     "Furthermore, whilst in treatment at Miracles Asia, clients are a part of a community.  Any non-attendance of activities by any client affects the recovery atmosphere at Miracles Asia and the collective recovery consciousness of the community as a whole.";

//   const text3 =
//     "If a client does not attend an activity or activities, it will be addressed by Miracles Asia staff. While the following will be determined on a case-by-case basis, in general, the following steps—taken by Miracles Asia staff—are likely to occur in the following order:";

//   const text4 =
//     "Step 1: A verbal and/or written directive to attend all activities";

//   const text5 =
//     "Step 2: If non-attendance continues after Step 1 above, then the following will occur: A Behavioural Support Agreement will be utilized.";

//   const text6 =
//     "Step 3: If non-attendance continues after Step 2 above, assessing on a case-by-case basis, an Administrative Discharge may occur (you may be asked to leave the program and possibly without a refund.)";

//   const text7 = "You are responsible for your recovery.";

//   const [, setIsSignatureStarted] = useState(false);

//   const handleCheckboxChange1 = (event) => {
//     setChecked1(event.target.checked);
//   };

//   const handleCheckboxChange2 = (event) => {
//     setChecked2(event.target.checked);
//   };

//   const handleCheckboxChange3 = (event) => {
//     setChecked3(event.target.checked);
//   };

//   const handleCheckboxChange4 = (event) => {
//     setChecked4(event.target.checked);
//   };

//   const handleCheckboxChange5 = (event) => {
//     setChecked5(event.target.checked);
//   };

//   const handleCheckboxChange6 = (event) => {
//     setChecked6(event.target.checked);
//   };

//   const handleCheckboxChange7 = (event) => {
//     setChecked7(event.target.checked);
//   };

//   const handleSignatureSave = (dataURL) => {
//     setSignatureDataURL(dataURL);
//   };

//   const uploadSignature = async () => {
//     const storage = getStorage();
//     const fileName = `${clientId}.png`;
//     const signatureRef = ref(
//       storage,
//       `MandatoryForms/TreatmentEngagementPolicy/${fileName}`
//     ); // Modifiez cette ligne

//     await uploadString(signatureRef, signatureDataURL, "data_url");
//     const downloadURL = await getDownloadURL(signatureRef);

//     return downloadURL;
//   };

//   const handleFormSubmit = async () => {
//     if (
//       !checked1 ||
//       !checked2 ||
//       !checked3 ||
//       !checked4 ||
//       !checked5 ||
//       !checked6 ||
//       !checked7 ||
//       !signatureDataURL ||
//       !isSignatureValidated
//     ) {
//       showCustomToast(
//         "Please agree to all the terms before submitting.",
//         "error"
//       );
//     }

//     try {
//       setIsLoading(true);
//       const signatureURL = await uploadSignature();
//       const docRef = doc(db, "TreatmentEngagementForm", props.clientId);
//       await setDoc(docRef, {
//         checked1,
//         checked2,
//         checked3,
//         checked4,
//         checked5,
//         checked6,
//         checked7,
//         text1,
//         text2,
//         text3,
//         text4,
//         text5,
//         text6,
//         text7,
//         signatureURL,
//         signedOn: serverTimestamp(),
//       });

//       const clientDocRef = firestoreDoc(db, "clients", props.clientId);
//       await updateDoc(clientDocRef, {
//         treatmentEngagementPolicyOk: true,
//         treatmentEngagementPolicyDateSigned: serverTimestamp(),
//       });
//       showCustomToast(
//         "Treatment program engagement form correctly submitted!",
//         "success"
//       );

//       setIsLoading(false);
//       props.closemodal();
//     } catch (e) {
//       showCustomToast("Error adding document", "error");
//       console.error("Error adding document: ", e);
//     }
//   };

//   const allChecked =
//     checked1 &&
//     checked2 &&
//     checked3 &&
//     checked4 &&
//     checked5 &&
//     checked6 &&
//     checked7;

//   return (
//     <>
//       <div style={{ width: "auto", height: "100%" }}>
//         <div className="line1-modal-percent">
//           <TopTitleFormComponent
//             title="TREATMENT PROGRAMME ENGAGEMENT POLICY FORM"
//             closemodal={props.closemodal}
//           />
//         </div>

//         <div
//           style={{
//             width: "100%",
//             marginTop: "3px",
//             height: "80%",
//             overflowY: "scroll",
//             // overflowX: "hidden",
//             paddingLeft: "15px",
//             paddingRight: "15px",
//           }}
//         >
//           <div className="SubTitleBold">
//             By signing this document you acknowledge that you understand and
//             agree to the following points:
//           </div>

//           <div className="checkbox-container-margin">
//             <Checkbox checked={checked1} onChange={handleCheckboxChange1} />
//             <div className="block-text-check">{text1}</div>
//           </div>

//           <div className="checkbox-container-margin">
//             <Checkbox checked={checked2} onChange={handleCheckboxChange2} />
//             <div className="block-text-check">{text2}</div>
//           </div>

//           <div className="checkbox-container-margin">
//             <Checkbox checked={checked3} onChange={handleCheckboxChange3} />
//             <div className="block-text-check">{text3}</div>
//           </div>

//           <div className="checkbox-container-margin">
//             <Checkbox checked={checked4} onChange={handleCheckboxChange4} />
//             <div className="block-text-check">{text4}</div>
//           </div>

//           <div className="checkbox-container-margin">
//             <Checkbox checked={checked5} onChange={handleCheckboxChange5} />
//             <div className="block-text-check">{text5}</div>
//           </div>

//           <div className="checkbox-container-margin">
//             <Checkbox checked={checked6} onChange={handleCheckboxChange6} />
//             <div className="block-text-check">{text6}</div>
//           </div>

//           <div className="checkbox-container-margin">
//             <Checkbox checked={checked7} onChange={handleCheckboxChange7} />
//             <div className="block-text-check">{text7}</div>
//           </div>

//           <div style={{ width: "100%", marginBottom: "25px" }}>
//             <SignaturePadComponentV2
//               onSignatureSave={handleSignatureSave}
//               signatureDataURL={signatureDataURL}
//               onSignatureStart={() => setIsSignatureStarted(true)}
//               onSignatureValidate={setIsSignatureValidated}
//             />
//           </div>
//         </div>
//         <div className="line4-modal-percent-bis">
//           <>
//             <Button
//               variant="contained"
//               style={{ backgroundColor: "white", color: "black" }}
//               // disabled={!(pic1Url && pic2Url && pic3Url && pic4Url && pic5Url)}
//               onClick={props.closemodal}
//             >
//               Cancel
//             </Button>
//             <Button
//               variant="contained"
//               onClick={handleFormSubmit}
//               style={
//                 isLoading
//                   ? {
//                       backgroundColor: "red",
//                       color: "white",
//                       marginLeft: "15px",
//                     }
//                   : !signatureDataURL || !isSignatureValidated || !allChecked
//                   ? {
//                       backgroundColor: "grey",
//                       color: "white",
//                       marginLeft: "15px",
//                     }
//                   : {
//                       backgroundColor: "#1565C0",
//                       color: "white",
//                       marginLeft: "15px",
//                     }
//               }
//               disabled={
//                 isLoading ||
//                 !signatureDataURL ||
//                 !allChecked ||
//                 !isSignatureValidated
//               }
//             >
//               {isLoading ? "SAVING..." : "SAVE"}
//             </Button>
//           </>
//         </div>
//       </div>
//     </>
//   );
// }

// export default AddTreatmentEngagementForm;

import React, { useState } from "react";
import { Button, Checkbox } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import TopTitleFormComponent from "./TopTitleFormComponent";
import "./AdmissionDocumentRedesign.css";
import { doc, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { updateDoc, doc as firestoreDoc } from "firebase/firestore";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadString,
} from "firebase/storage";
import { showCustomToast } from "../Misc/CustomToast";
import SignaturePadComponentV2 from "../Signature/SignaturePadComponentV2";

function AddTreatmentEngagementForm({ clientId, ils, firstName, lastName, closemodal }) {
  const [checked1, setChecked1] = useState(false);
  const [checked2, setChecked2] = useState(false);
  const [checked3, setChecked3] = useState(false);
  const [checked4, setChecked4] = useState(false);
  const [checked5, setChecked5] = useState(false);
  const [signatureDataURL, setSignatureDataURL] = useState(null);
  const [isSignatureValidated, setIsSignatureValidated] = useState(false);
  const [, setIsSignatureStarted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const allChecked = checked1 && checked2 && checked3 && checked4 && checked5;

  const handleSignatureSave = (dataURL) => {
    setSignatureDataURL(dataURL);
  };

  console.log("Ils:", ils);

  const uploadSignature = async () => {
    const storage = getStorage();
    const fileName = `${clientId}.png`;
    const signatureRef = ref(
      storage,
      `MandatoryForms/TreatmentEngagementPolicy/${fileName}`
    );
    await uploadString(signatureRef, signatureDataURL, "data_url");
    return await getDownloadURL(signatureRef);
  };

  const handleFormSubmit = async () => {
    if (!allChecked || !signatureDataURL || !isSignatureValidated) {
      showCustomToast(
        "Please check all the boxes and sign before submitting.",
        "error"
      );
      return;
    }

    try {
      setIsLoading(true);
      const signatureURL = await uploadSignature();

      const docRef = doc(db, "TreatmentEngagementForm", clientId);
      const formData = {
        checked1,
        checked2,
        checked3,
        checked4,
        checked5,
        signatureURL,
        signedOn: serverTimestamp(),
      };

      if (ils !== undefined && ils !== null && ils !== "") {
        formData.intendedLengthOfStay = ils;
        formData.durationOfStay = ils;
      }

      await setDoc(docRef, formData);

      const clientDocRef = firestoreDoc(db, "clients", clientId);
      await updateDoc(clientDocRef, {
        treatmentEngagementPolicyOk: true,
        treatmentEngagementPolicyDateSigned: serverTimestamp(),
      });

      showCustomToast(
        "Engagement form successfully submitted!",
        "success"
      );
      setIsLoading(false);
      closemodal();
    } catch (e) {
      console.error("Error adding document: ", e);
      showCustomToast("Error while saving the form.", "error");
      setIsLoading(false);
    }
  };

  return (
    <div className="admission-document-shell admission-card-form-shell treatment-engagement-form-shell">
      <TopTitleFormComponent
        title="Treatment programme engagement policy form"
        eyebrow="Admission form"
        subtitle={`${firstName || "Client"} ${lastName || ""}`.trim()}
        closemodal={closemodal}
      />

      <div
        style={{
          width: "100%",
          marginTop: 3,
          height: "80%",
          overflowY: "scroll",
          padding: "0 15px",
        }}
      >
        <div
          className="block-text-check"
          style={{ paddingLeft: "20px", paddingRight: "20px" }}
        >
          Miracles Asia’s treatment programme schedules various activities
          throughout the week. The programme, in its entirety, exists to help
          clients in their treatment and to build a strong foundation for
          maintaining their recovery, which includes participating in the
          community of clients at Miracles Asia.
        </div>

        <div className="SubTitleBold">
          By signing this document I acknowledge and agree to the following:
        </div>

        <div
          className="checkbox-container-margin"
          style={{ display: "flex", alignItems: "flex-start" }}
        >
          <div style={{ paddingTop: "11px" }}>
            <Checkbox
              checked={checked1}
              onChange={(e) => setChecked1(e.target.checked)}
            />
          </div>

          <div className="block-text-check">
            I agree to attend all programme activities throughout my stay at
            Miracles Asia unless prior to the activity I am excused from that
            activity by:
            <ul className="nested-list">
              <li>a medical waiver</li>
              <li>if I am required to attend to an immigration issue</li>
              <li>
                my primary therapist, the Clinical Director, or the Managing
                Director
              </li>
            </ul>
          </div>
        </div>

        <div
          className="checkbox-container-margin"
          style={{ display: "flex", alignItems: "flex-start" }}
        >
          <div style={{ paddingTop: "11px" }}>
            <Checkbox
              checked={checked2}
              onChange={(e) => setChecked2(e.target.checked)}
            />
          </div>
          <div className="block-text-check">
            I understand that not attending an activity without being excused
            may result in the following actions:
            <ul className="nested-list">
              <li>
                Step 1: Verbal and/or written directive to attend all subsequent
                activities
              </li>
              <li>
                Step 2: Initiating a Behavioural Support Agreement created by
                the clinical team
              </li>
              <li>
                Step 3: A case-by-case review by the clinical team to determine
                the next appropriate action
              </li>
            </ul>
          </div>
        </div>

        <div className="checkbox-container-margin">
          <Checkbox
            checked={checked3}
            onChange={(e) => setChecked3(e.target.checked)}
          />

          <div className="block-text-check">
            I understand that my Intended Length of Stay as an in-house client
            will be <strong>{ils}</strong>
          </div>
        </div>

        <div className="checkbox-container-margin">
          <Checkbox
            checked={checked4}
            onChange={(e) => setChecked4(e.target.checked)}
          />
          <div className="block-text-check">
            I understand that I am responsible for my recovery
          </div>
        </div>

        <div
          className="checkbox-container-margin"
          style={{ display: "flex", alignItems: "flex-start" }}
        >
          <div style={{ paddingTop: "11px" }}>
            <Checkbox
              checked={checked5}
              onChange={(e) => setChecked5(e.target.checked)}
            />
          </div>
          <div className="block-text-check">
            I agree to participate in all aspects of my treatment and to follow
            the treatment plans provided to me by my therapists and doctors to
            the best of my ability
          </div>
        </div>

        <div style={{ width: "100%", marginBottom: 25 }}>
          <SignaturePadComponentV2
            onSignatureSave={handleSignatureSave}
            signatureDataURL={signatureDataURL}
            onSignatureStart={() => setIsSignatureStarted(true)}
            onSignatureValidate={setIsSignatureValidated}
          />
        </div>
      </div>

      <div className="line4-modal-percent-bis">
        <Button
          variant="contained"
          style={{ backgroundColor: "white", color: "black" }}
          onClick={closemodal}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleFormSubmit}
          disabled={
            isLoading ||
            !allChecked ||
            !signatureDataURL ||
            !isSignatureValidated
          }
          style={
            isLoading
              ? { backgroundColor: "red", color: "white", marginLeft: 15 }
              : !allChecked || !signatureDataURL || !isSignatureValidated
              ? { backgroundColor: "grey", color: "white", marginLeft: 15 }
              : { backgroundColor: "#1565C0", color: "white", marginLeft: 15 }
          }
        >
          {isLoading ? "SAVING..." : "SAVE"}
        </Button>
      </div>
    </div>
  );
}

export default AddTreatmentEngagementForm;
